module.exports = __webpack_public_path__ + "1_0_62/img/auth_logo.a365e40d.svg";